module.exports = __webpack_public_path__ + "0aaa6e607150d3b28df55f13e99c96e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-main-320.jpg
// module id = 323
// module chunks = 0